import React, { JSX, ReactNode } from 'react';
import { Box, Container } from '@mui/material';
import { Header } from './Header';
import { ILayoutProps } from './layout.types';
import { layoutContainerStyles, containerStyles } from './layout.styles';
import { Footer } from './footer';

export const Layout = (props: ILayoutProps): JSX.Element => {
    return (
        <Box sx={layoutContainerStyles}>
            <Header />
            <Box component="main" sx={containerStyles}>
                <Container maxWidth="lg">
                    {props.children}
                </Container>
            </Box>
            <Footer />
        </Box>
    );
};